import $ from 'jquery';
import { Interval } from 'utilities/types';

export const buildPauseEpisodeInterval = ({ fromX, toX, content, chartHeight, chartWidth }: Interval) => {
  const height = chartHeight ?? 130;
  const top = 0;

  const maxRight = (chartWidth ?? 1200) - 100;
  const isPartialLeft = fromX < 0;
  const isPartialRight = toX > maxRight;

  const left = isPartialLeft ? 0 : fromX;
  const right = isPartialRight ? maxRight : toX;

  const width = right - left;

  const container = $('<div></div>').css({
    top,
    left,
    width,
    height,
    position: 'absolute',
  });

  const ruler = $(`
    <div class="ruler-pause">
        <div class="content">
            ${content}
        </div>
  </div>`);

  container.append(ruler);

  container.addClass('uplot-additional-element');

  return container;
};
